module.exports = __webpack_public_path__ + "Flag-756.a1c3de535723634fe12aefd2d213f249.svg";